/* jshint esversion: 6 */
import React, { lazy, Suspense } from 'react';
import CommonRouter from 'app/components/Routers/CommonRouter.jsx';
import { Route, Navigate } from 'react-router';
const ClientApp = lazy(() => import(/* webpackChunkName: "ClientApp" */ 'app/components/ClientApp/ClientApp.jsx'));
import ClientSocials from 'app/views/Client/ClientSocials.jsx';
import ClientSocialEditor from 'app/views/Client/ClientSocialEditor.jsx';
import ClientAccount from 'app/views/Client/ClientAccount.jsx';
import SocialLogPanel from 'app/components/EditorComponents/SocialLogPanel.jsx';
import ClientSubaccountSelector from 'app/views/Client/ClientSubaccountSelector.jsx';
import RouterError from 'app/components/Routers/RouterError.jsx';
import Loading from 'app/components/common/Loading.jsx';

export default function ClientRouter() {
    let routes = (
        <Route path="/" element={<Suspense fallback={<Loading/>}><ClientApp/></Suspense>} errorElement={<RouterError/>}>
            <Route index element={<ClientSocials/>} />
            <Route path="/socials" element={<ClientSocials/>}>
                <Route path="detail/:socialId" element={<ClientSocials/>}/>
            </Route>
            <Route path="/chooser" element={<ClientSubaccountSelector/>}/>
            <Route path="/social/:socialId" element={<ClientSocialEditor/>}>
                <Route path="log" element={<SocialLogPanel/>}/>
            </Route>
            <Route path="/account" element={<ClientAccount/>}/>
            <Route path="/config/socials" element={<Navigate to="/socials" replace/>}/>
            <Route path="/config/chooser" element={<Navigate to="/chooser" replace/>}/>
            <Route path="/share/automate" element={<Navigate to="/socials" replace/>}/>
        </Route>
    );

    return (
        <CommonRouter routes={routes}/>
    );
}
